import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from "./FileAppResource";
import WorkspaceAppResource from "./WorkspaceAppResource";
import OrganizationAppResource from "./OrganizationAppResource";
import UserAppResource from "./UserAppResource";

class FileDownloadTokenAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'file-download-token';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'file-download-tokens';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'created_at',
            'updated_at',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'token',
            'fileUuid',
            'userUuid',
            'organizationUuid',
            'organizationMemberUuid',
            'workspaceOrganizationMemberUuid',
            'expiredAt',
            'maxDownloads',
            'downloads',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            user: UserAppResource,
            file: FileAppResource,
            organization: OrganizationAppResource,
            workspace: WorkspaceAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            user: 'userUuid',
            file: 'fileUuid',
            workspace: 'workspaceUuid',
            organization: 'organizationUuid'
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            fileUuid: {
                type: 'string',
                presence: true,
            },
            organizationUuid: {
                type: 'string',
            },
            workspaceUuid: {
                type: 'string',
            },
            maxDownloads: {
                numericality: {
                    notLessThanOrEqualTo: 1,
                },
            },
            expiresAt: {
                type: 'string',
                datetime: true,
            },
            token: {
                type: 'string',
            },
        };
    }
}

export default FileDownloadTokenAppResource;
